import { Box, ButtonGroup, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { t } from 'i18next';
import { FiEdit, FiTrash } from 'react-icons/fi';

export default function WorkflowItem() {
	return (
		<Box
			bg="white"
			borderWidth={1}
			borderColor="gray.100"
			borderRadius="md"
			py={2}
			px={4}
			display="grid"
			gridTemplateColumns="1fr auto"
			alignItems="center"
		>
			<Box>
				<Text fontSize="sm" fontWeight={500}>
					Create event in calendar
				</Text>
				<Text fontSize="xs">When a booking is confirmed</Text>
			</Box>
			<ButtonGroup>
				<ButtonGroup isAttached size="sm" variant="ghost">
					<Tooltip label={t('Edit availability')}>
						<IconButton icon={<FiEdit />} aria-label="Edit" />
					</Tooltip>
					<Tooltip label={t('Remove')}>
						<IconButton icon={<FiTrash />} aria-label="Remove" />
					</Tooltip>
				</ButtonGroup>
			</ButtonGroup>
		</Box>
	);
}
